import { pushToDataLayer } from '@app/infrastructure/gtm/pushToDataLayer';
import { EcommerceEventData } from '@app/domain/model/gtm/EcommerceEventData';

export function pushEcommerceEvent(event: string, ecommerce: EcommerceEventData): void {
    pushToDataLayer(event, { ecommerce: null });
    pushToDataLayer(event, { ecommerce });
}
